import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, Output, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-spinner-button',
  templateUrl: './spinner-button.component.html',
  styleUrls: ['./spinner-button.component.scss']
})
export class SpinnerButtonComponent implements AfterViewInit {
  @Input() disabled: boolean;
  @Input() processing: boolean;
  @Input() buttonText: string;
  @Input() matIcon: string;
  @Input() fontSet: string;
  @Input() flatButton: boolean;
  @Input() color: string;
  @Input() type: string;
  @Input() camelCase = false;
  @Input() width: string;

  @Output() buttonClick: EventEmitter<void> = new EventEmitter();

  @ViewChild('spinnerButton', { read: ElementRef }) button: ElementRef;
  @HostBinding('class.spinner-button-no-color') get noColor() {return !this.color;}

  constructor(public renderer: Renderer2) {
  }

  ngAfterViewInit() {
    if (this.width) {
      return;
    }

    // Holds button to original size
    const button = this.button.nativeElement;

    const height = button.offsetHeight;
    const width = button.offsetWidth;

    if (!!height && !!width) {
      this.renderer.setStyle(button, 'width', width + 'px');
      this.renderer.setStyle(button, 'height', height + 'px');
    }
  }

  emitButtonClick(event) {
    event.stopPropagation();
    if (!this.isDisabled()) {
      this.buttonClick.emit();
    }
  }

  isDisabled(): boolean {
    return this.processing || this.disabled;
  }
}
